import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class AdvertisementService {
  header;
  constructor(private http: HttpClient) {
    this.header = new HttpHeaders()
    .set('Content-type', 'application/json');
   }

   getBannerList(EstimationServiceTypeID ,page, lang) {
    return this.http
      .get<any>(environment.apiUrl + `Adertisement/GetBannerList/` +EstimationServiceTypeID + '/'+ page + `/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getAllPurchedRecordOfBannerdAdByCompanyID(companyId, lang) {
    return this.http
      .get<any>(environment.apiUrl + `Adertisement/GetAllPurchedRecordOfBannerdAdByCompanyID/` + companyId + `/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  registerAdvertisementBanner(RegiInfo) {
    return this.http
      .post<any>(environment.apiUrl + `Adertisement/RegisterAdvertisementBanner`, JSON.stringify({RegiInfo}), { headers: this.header })
      .pipe(
        map(res => {
          return res;
        })
      );
  }




}
